import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    showDialog: false,
    pinId: null
};

export const projectPinDialogSlice = createSlice({
    name: "generalPinDialog",
    initialState,
    reducers: {
        updatedprojectPinDialog: (state, action) => {
            state.showDialog = action.payload.showDialog;
            state.pinId = action.payload.pinId;
        }
    },
});

export const { updatedprojectPinDialog } = projectPinDialogSlice.actions;
export default projectPinDialogSlice.reducer;